import ReactDOM from "react-dom";
import React, { useEffect, useRef, useState } from 'react';
import langData from '../locales/langData.json';
import vid from '../assets/images/video-thum.webp';
import ProductFeatureFeder from '../components/ProductFeaturefederation';
import centerBox from '../assets/images/web-plat.webp';
import centerBoxMob from '../assets/images/mob-center-icon.svg';
import arrow from '../assets/images/right-arrow.webp';
import FaqFederation from '../components/FaqFederation';
import playicon from '../assets/images/play-icon.webp'
import DemoForm from '../components/Forms/DemoForm';
import SEO from '../components/SEO';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ClientLogoMarquee from '../components/ClientLogoMarquee';


// ✅ Reusable CountUp component
const CountUp = ({ end, duration, trigger }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!trigger) return; // wait until visible
        let start = 0;
        const incrementTime = 10;
        const totalSteps = (duration * 1000) / incrementTime;
        const increment = end / totalSteps;

        const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
                clearInterval(timer);
                setCount(end);
            } else {
                setCount(Math.floor(start));
            }
        }, incrementTime);

        return () => clearInterval(timer);
    }, [end, duration, trigger]);

    return <>{count}</>;
};



const Federations = ({ language }) => {
    const federation = langData[language].federation;
    const product = langData[language].products;
    const clientlogos = langData[language].clientlogo;
    const imgRef = useRef(null);
 const counterRef = useRef(null);

    const [showModal, setShowModal] = useState(false);
    const [visible, setVisible] = useState(false);



    // ✅ Scroll fade-in animation
    useEffect(() => {
        const handleScroll = () => {
            const element = imgRef.current;
            if (!element) return;

            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const progress = 1 - rect.top / windowHeight;
            const clamped = Math.min(Math.max(progress, 0), 1);

            element.style.opacity = 1;
            element.style.transform = `translateY(${180 - clamped * 160}px)`;
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ✅ IntersectionObserver for CountUp
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) setVisible(true);
            },
            { threshold: 0.3 }
        );

        if (counterRef.current) observer.observe(counterRef.current);
        return () => observer.disconnect();
    }, []);



    return (
        <>
            <SEO
                title="CaptainX Federation | Sports Federation Management Solution"
                titleAr="اتحادات كابتن اكس | حلول إدارة الاتحادات الرياضية والأندية"
                description="Empower your sports federations and clubs with intelligent solutions to streamline operations, enhance transparency through analytics, and boost member engagement."
                descriptionAr="قم بتزويد اتحاداتك وأنديتك الرياضية بحلول ذكية لتبسيط العمليات وتعزيز الشفافية من خلال التحليلات وتعزيز مشاركة الأعضاء."
                path="/products/federations"
                language={language}
            />

              {showModal &&
                            ReactDOM.createPortal(
                               <DemoForm
              language={language}
              onClose={() => setShowModal(false)}
            />,
            
                                document.body
                            )
                        }
            

            <div className="indual-product-section">
                <div className="m-indu-first">
                    <div className="container">
                        <center>
                            <div className="indual-hero-m">
                                <div className="cen-sec-con">

                                    <h6 className='sec-top-titl block-view mt-3'>{federation.secTopTitle}</h6>
                                    <h2
                                        className='sec-title block-view'
                                        dangerouslySetInnerHTML={{ __html: federation.title }}
                                    />
                                    <p className='block-view sec-p'>{federation.desc}</p>
                                    <div className="mob-btn">

                                        <button
                                            className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                                } `} 
                                                 onClick={() => setShowModal(true)}
                                        > {federation.btn}

                                            <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </center>

                        <div className="ind-img-over scroll-fade-scroll" ref={imgRef}>
                            <LazyLoadImage src={vid} alt="video-thumb" className="scroll-fade-scroll" />
                            <div className="play-icon">
                                <LazyLoadImage src={playicon} alt="play-icon" />
                            </div>
                        </div>
                    </div>

                    <div className="scond-product-part">
                        <div className="marq">
                            <center>
                                <h5 className="second-cen-text pt-3">{product.morequee}</h5>
                                <ClientLogoMarquee logos={clientlogos} language={language} />
                            </center>
                        </div>
                    </div>
                </div>
            </div>


            {/* ✅ Number Counter Section */}
            <section className='future-sec'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">

                        {/* LEFT CONTENT */}
                        <div className="col-md-6 " ref={counterRef}>
                            <h2
                                className="sec-title futer-title block-view"
                                dangerouslySetInnerHTML={{ __html: federation.futureTitle }}
                            />
                            <p className="sec-p futer-p block-view">{federation.futureDesc}</p>
                        </div>

                        <div className="col-md-2"></div>

                        {/* RIGHT NUMBERS */}
                        <div className="col-md-4">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="num-card-box ">
                                        <div className="number-count">
                                            <CountUp end={federation.num1} duration={2} trigger={visible} />
                                            <span>{federation.numspan}</span>
                                        </div>
                                        <div className="number-desc">{federation.num1Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={federation.num2} duration={2} trigger={visible} />
                                            <span>{federation.numspan}</span>
                                        </div>
                                        <div className="number-desc">{federation.num2Desc}</div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="num-card-box num-box-2">
                                        <div className="number-count-two">
                                            <CountUp end={federation.num3} duration={2} trigger={visible} />
                                            <span>{federation.numspan}</span>
                                        </div>
                                        <div className="number-desc">{federation.num3Desc}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <ProductFeatureFeder language={language} />


            {/* PLATFORM SECTION */}
            <section className='platform'>
                <div className="container">
                    <center>
                        <h2 className='sec-title'>{federation.platformTitle}</h2>
                        {/* <p className='d-none d-md-block sec-desc'>{federation.platformDesc}</p> */}
                    </center>

                    <div className="row justify-content-center align-items-center mt-5">
                        <div className="col-md-4 d-block d-md-none mb-4">
                            <center>
                                <LazyLoadImage src={centerBoxMob} alt="center-box " className='img-fluid d-block d-md-none' />
                                <LazyLoadImage src={centerBox} alt="center-box " className='img-fluid d-none d-md-block' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap">
                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={federation.platformlist1icon} alt={federation.platformlist1icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{federation.platformlist1Title}</h6>
                                        <p>{federation.platformlist1Desc}</p>
                                    </div>
                                </div>

                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={federation.platformlist2icon} alt={federation.platformlist2icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{federation.platformlist2Title}</h6>
                                        <p>{federation.platformlist2Desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 d-none d-md-block">
                            <center>
                                <LazyLoadImage src={centerBox} alt="center-box" className='img-cen' />
                            </center>
                        </div>

                        <div className="col-md-4">
                            <div className="card-wrap">
                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={federation.platformlist3icon} alt={federation.platformlist3icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{federation.platformlist3Title}</h6>
                                        <p>{federation.platformlist3Desc}</p>
                                    </div>
                                </div>

                                <div className="icon-box">
                                    <div className="icon">
                                        <LazyLoadImage src={federation.platformlist4icon} alt={federation.platformlist4icon} />
                                    </div>
                                    <div className="icon-box-con">
                                        <h6>{federation.platformlist4Title}</h6>
                                        <p>{federation.platformlist4Desc}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <FaqFederation language={language} />


            {/* CTA */}
            <section className='cta py-5 my-4'>
                <div className="container">
                    <center>
                        <h2
                            className='sec-title block-view'
                            dangerouslySetInnerHTML={{ __html: federation.ctaTitle }}
                        ></h2>
                        <p
                            className="sec-p block-view"
                            dangerouslySetInnerHTML={{ __html: federation.ctadesc }}
                        ></p>

                        
                         <button
                                                    className={`explore-btn cta-btn my-4 py-2 gap-3 block-view ${language === "ar" ? "ar-padding" : "en-padding"
                                                        } `}
                                                    onClick={() => setShowModal(true)}
                                                >
                                                    {federation.ctabutton}
                                                    <LazyLoadImage src={arrow} alt="arrow" className="rt-btn" />
                                                </button>

                    </center>
                </div>
            </section>
        </>
    );
};

export default Federations;
